import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import PieChart from 'components/@common/Charts/PieChart';
import ChartLayout from './ChartLayout';
import { toPercentageDecimal } from '../SplitProgressBarChart/util';
import { PrmActiveStudentsReportResult } from 'types/schema-generated-types';

type Props = {
  activeStudentsReportData: PrmActiveStudentsReportResult;
};

const ActiveStudentsChart: React.FC<Props> = ({ activeStudentsReportData }) => {
  const classes = useStyles();

  const reportData = activeStudentsReportData ?? {
    activeStudentCount: 0,
    totalStudentCount: 0
  };

  const percent =
    Math.round(
      toPercentageDecimal(reportData?.activeStudentCount!, reportData?.totalStudentCount!)
    ) || 0;

  return (
    <ChartLayout
      Left={
        <PieChart
          type="radialBar"
          series={[percent]}
          height={250}
          options={{
            tooltip: {
              y: {
                formatter: (data: any) => `${data}%`,
                title: {
                  formatter: () => 'Active Students:'
                }
              }
            },
            stroke: {
              lineCap: 'round'
            },
            plotOptions: {
              radialBar: {
                dataLabels: {
                  name: {
                    fontSize: '22px'
                  },
                  value: {
                    fontSize: '32px',
                    offsetY: -10
                  },
                  total: {
                    show: true,
                    label: ' '
                  }
                }
              }
            },
            colors: ['#9A6CAF']
          }}
        />
      }
      Right={
        <>
          <Box display="flex">
            <Typography className={classes.title}>Active Students</Typography>
          </Box>
          <Typography variant="h3">
            {reportData?.activeStudentCount} of {reportData?.totalStudentCount}
          </Typography>
        </>
      }
    />
  );
};

const useStyles = makeStyles(theme => ({
  title: { fontSize: 18 }
}));

export default ActiveStudentsChart;
